import React from "react";

const FinlexTreaty = ({ docData, lang, sideData, highlightContent}) => {


    // Format text to html
    function formatContent(content) {
        return {
        __html: !sideData.termCounts
            ? content
            : highlightContent(content, sideData.termCounts),
        };
    }

    // Format html as html
    // Allows only certain tags, so we are not injecting anything dangerous
    function validateContent(html_content) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html_content, 'text/html');
    
        // Remove <script>, <style>, <iframe>, and other risky tags
        const forbiddenTags = ['script', 'style', 'iframe', 'object', 'embed'];
        forbiddenTags.forEach(tag => {
        doc.querySelectorAll(tag).forEach(node => node.remove());
        });

        // URI attributes that can be dangerous
        const uriAttributes = ['href', 'src', 'xlink:href', 'formaction'];

    
        // Remove dangerous attributes (like onClick, onLoad, javascript:)
        doc.querySelectorAll('*').forEach(node => {
        [...node.attributes].forEach(attr => {
            const name = attr.name.toLowerCase();
            const value = attr.value.toLowerCase();
    
            // Remove event handlers or javascript URLs
            if (name.startsWith('on')) {
            node.removeAttribute(attr.name);
            }
            // Remove 'javascript:' from URI attributes
            // eslint-disable-next-line no-script-url
            if (uriAttributes.includes(name) && value.startsWith('javascript:')
            ) {
            node.removeAttribute(attr.name);
            }
        });
        });
    
        // Return sanitized HTML
        return { __html: doc.body.innerHTML };
    }

    return(
        <>
        {
        lang === 'se' ?
            (
            docData._source.content_sv ? 
                <div
                className="doc-content"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={formatContent(
                    docData._source.content_sv
                )}
                />
            : <></>
            ) :
            (
            docData._source.content ? 
                <div
                    className="doc-content"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={formatContent(
                    docData._source.content
                    )}
                />
            : <></>
            )
        }
    
        {
        lang === 'se' ?
            (
            docData._source.html_content_sv ? 
                <div
                className="doc-content"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={validateContent(
                    docData._source.html_content_sv
                )}
                />
                : <></>
            ) :
            (
            docData._source.html_content ? 
            <div
                className="doc-content"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={validateContent(
                    docData._source.html_content
                )}
            />
            : <></>
            )
        }
    
        </>
    )
};

  export default FinlexTreaty;